import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";

const loadLoyaltyIsEnabled = createAsyncThunk(
  "config/loadLoyaltyIsEnabled",
  async (_, { rejectWithValue }) => {
    try {
      const loyaltySdk = await sdkProvider("loyalty");
      const isLoyaltyEnabled = await loyaltySdk.isLoyaltyAvailable();

      return isLoyaltyEnabled;
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadLoyaltyIsEnabled failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  }
);

export default loadLoyaltyIsEnabled;
